<template>
    <v-radio-group v-model="model" :row="getIsHorizontal" @change="emitChangeEvent" v-if="getIsVisible">
        <v-radio v-for="n in valueItem.items"
                 :key="n.id"
                 :label="n.text"
                 :value="n.id" dense></v-radio>
    </v-radio-group>
</template>
<script>
    export default {
        props: ['valueItem', 'isHorizontal'],
        computed: {
            model: {
                get() {
                    return this.valueItem.value;
                },
                set(value) {
                    this.valueItem.value = value;
                }
            },
            getIsHorizontal: function () {
                if (this.isHorizontal == 'undefined') return false;
                return this.isHorizontal;
            },
            getIsVisible: function () {
                return this.valueItem ? true : false;
            }
        },
        methods: {
            emitChangeEvent: function () {
                this.$emit('change');
            },
        }
    }
</script>